export default __webpack_public_path__ + "static/media/pdf.0af53fc0.svg";